import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const customUrlFn = (id) => `/exports${id ? '/'+id : ''}`

const state = {
  isDownloading: false
}

const actions = {
  download({ commit }, { id, config }) {
    const url = customUrlFn(id) + '/download';
    
    return api.client.get(url, config)
      .then(res => {
        commit('downloadEnd')
        const blob = new Blob([res.data], { type: res.headers['content-type'] })
        return Promise.resolve(blob);
      })
      .catch(err => {
        commit('downloadEnd')
        return Promise.reject(err.response.data);
      })
  }
}

const mutations = {
  downloadStart(state) {
    state.isDownloading = true;
  },

  downloadEnd(state) {
    state.isDownloading = false;
  }
}

export default createCrudModule({
  client: api.client,
  resource: 'data_exports',
  only: [ 'FETCH_SINGLE', 'CREATE' ],
  urlRoot: '/exports',
  parseSingle: res => res.data,
  state,
  actions,
  mutations
});